(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamaruta-set"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(cents) {
      var s = (cents / 100).toFixed(2).replace('.', ',');
      return s.replace(',00', '') + ' lei';
    }
    function update(root) {
      if (!root) return;
      var base = parseInt(root.dataset.total, 10) || 0;
      var threshold = parseInt(root.dataset.threshold, 10) || 0;
      var cb = root.querySelector('[data-mm-addon]');
      var total = base + (cb && cb.checked ? parseInt(cb.dataset.price, 10) || 0 : 0);
      var totalEl = root.querySelector('[data-mm-total]');
      if (totalEl) totalEl.textContent = fmt(total);
      var ship = root.querySelector('[data-mm-ship]');
      if (!ship) return;
      if (total >= threshold) {
        ship.textContent = 'transport gratuit';
        ship.classList.add('is-free');
      } else {
        ship.textContent = 'mai adaugă ' + fmt(threshold - total) + ' pentru transport gratuit';
        ship.classList.remove('is-free');
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-mm-addon]')) update(e.target.closest('[data-mm-set]'));
    });
    document.addEventListener('click', function (e) {
      var pickBtn = e.target.closest && e.target.closest('[data-mm-pick-add]');
      if (pickBtn) {
        e.preventDefault();
        var pickRoot = pickBtn.closest('[data-mm-set]');
        var pickErr = pickRoot && pickRoot.querySelector('[data-mm-error]');
        if (pickErr) pickErr.hidden = true;
        pickBtn.disabled = true;
        pickBtn.setAttribute('aria-busy', 'true');
        fetch(pickBtn.dataset.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(pickBtn.dataset.variant, 10), quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            window.location.href = pickBtn.dataset.cart;
          })
          .catch(function () {
            pickBtn.disabled = false;
            pickBtn.removeAttribute('aria-busy');
            if (pickErr) pickErr.hidden = false;
          });
        return;
      }
      var btn = e.target.closest && e.target.closest('[data-mm-set-add]');
      if (!btn) return;
      e.preventDefault();
      var root = btn.closest('[data-mm-set]');
      var ids = JSON.parse(btn.dataset.variants || '[]');
      var cb = root && root.querySelector('[data-mm-addon]');
      if (cb && cb.checked) ids.push(parseInt(cb.value, 10));
      var err = root && root.querySelector('[data-mm-error]');
      if (err) err.hidden = true;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      fetch(btn.dataset.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          window.location.href = btn.dataset.cart;
        })
        .catch(function () {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (err) err.hidden = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
